var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFileDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 39 49",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.667 16.772a3.168 3.168 0 0 0-.145-.653v-.217a2.586 2.586 0 0 0-.46-.677l-14.5-14.5a2.586 2.586 0 0 0-.676-.46h-.242A2.66 2.66 0 0 0 21.895 0H7.25A7.25 7.25 0 0 0 0 7.25v33.833a7.25 7.25 0 0 0 7.25 7.25h24.167a7.25 7.25 0 0 0 7.25-7.25V16.772Zm-14.5-8.531 6.259 6.259h-3.843a2.417 2.417 0 0 1-2.416-2.417V8.241Zm9.666 32.842a2.417 2.417 0 0 1-2.416 2.417H7.25a2.417 2.417 0 0 1-2.417-2.417V7.25A2.417 2.417 0 0 1 7.25 4.833h12.083v7.25a7.25 7.25 0 0 0 7.25 7.25h7.25v21.75ZM22.451 29.701l-.701.725v-6.26a2.417 2.417 0 1 0-4.833 0v6.26l-.701-.725a2.427 2.427 0 1 0-3.432 3.431l4.833 4.834c.23.22.501.392.798.507a2.271 2.271 0 0 0 1.837 0c.296-.115.567-.287.797-.507l4.834-4.834a2.426 2.426 0 0 0-3.432-3.431Z"
})));

export default SvgFileDownload;